<template>
  <div class="alert" :data-variant="props.type">
    <BaseTypography v-if="props.title" class="text-lg font-semibold" variant="p" disable-ellipsis>
      {{ props.title }}
    </BaseTypography>
    <p v-if="props.content">{{ props.content }}</p>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
interface AlertProps {
  type: "success" | "error";
  title?: string;
  content?: string | null;
}
const props = defineProps<AlertProps>();
</script>

<style scoped lang="scss">
.alert {
  @apply rounded-md border border-current p-3 px-4;

  &[data-variant="success"] {
    @apply bg-green-100 text-green-700;
  }

  &[data-variant="error"] {
    @apply bg-red-100 text-red-700;
  }
}
</style>
